import { styled } from '@vebox/etui-system';
import { Component, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import { findDOMNode } from 'react-dom';

const _excluded = ["theme"];
const AvatarWrapper = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    m: 0,
    p: 0,
    display: 'inline-block',
    bg: theme.palette.grey['60'],
    color: theme.palette.common.white,
    borderRadius: '100%'
  }, rest);
})`
  list-style: none;
  text-align: center;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  width: 32px;
  height: 32px;
`;

const AvatarContent = styled(Span)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const _excluded$1 = ["shape", "size", "src", "icon", "styles"];
class Avatar extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setScale", () => {
      const childrenNode = this.avatarChildren;
      if (childrenNode) {
        const childrenWidth = childrenNode.offsetWidth;
        // eslint-disable-next-line react/no-find-dom-node
        const avatarNode = findDOMNode(this);
        const avatarWidth = avatarNode.getBoundingClientRect().width;
        if (avatarWidth - 8 < childrenWidth) {
          this.setState({
            scale: (avatarWidth - 8) / childrenWidth
          });
        } else {
          this.setState({
            scale: 1
          });
        }
      }
    });
    _defineProperty(this, "handleImgLoadError", () => this.setState({
      isImgExist: false
    }));
    this.state = {
      scale: 1,
      isImgExist: true
    };
  }
  componentDidMount() {
    this.setScale();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.children !== this.props.children || prevState.scale !== this.state.scale && this.state.scale === 1 || prevState.isImgExist !== this.state.isImgExist) {
      this.setScale();
    }
  }
  render() {
    const _this$props = this.props,
      {
        shape,
        size,
        src,
        icon,
        styles
      } = _this$props,
      others = _objectWithoutProperties(_this$props, _excluded$1);
    let {
      children
    } = this.props;
    if (src && this.state.isImgExist) {
      children = /*#__PURE__*/createElement("img", {
        src: src,
        alt: "error",
        onError: this.handleImgLoadError
      });
    } else if (icon) {
      children = /*#__PURE__*/createElement(Icon, {
        glyph: icon
      });
    } else {
      const childrenNode = this.avatarChildren;
      if (childrenNode || this.state.scale !== 1) {
        const childrenStyle = {
          msTransform: `scale(${this.state.scale})`,
          WebkitTransform: `scale(${this.state.scale})`,
          transform: `scale(${this.state.scale})`,
          position: 'absolute',
          display: 'inline-block',
          left: `calc(50% - ${Math.round(childrenNode.offsetWidth / 2)}px)`
        };
        children = /*#__PURE__*/createElement("span", {
          // eslint-disable-next-line no-return-assign
          ref: span => this.avatarChildren = span,
          style: childrenStyle
        }, children);
      } else {
        children =
        /*#__PURE__*/
        // eslint-disable-next-line no-return-assign
        createElement("span", {
          ref: span => this.avatarChildren = span
        }, children);
      }
    }
    return /*#__PURE__*/createElement(AvatarWrapper, _extends({
      testId: "avatar"
    }, others, styles.root), /*#__PURE__*/createElement(AvatarContent, null, children));
  }
}
_defineProperty(Avatar, "defaultProps", {
  shape: 'circle',
  size: 'default',
  styles: {}
});

export default Avatar;
